'use strict';

import React from 'react';
import App from './App';

React.render(<App />, document.body);



/** WEBPACK FOOTER **
 ** ./scripts/index.js
 **/